import { useTranslation } from 'react-i18next';
import type { TimedSettlementFinancialTotals } from '@pokerroom/types';

/** Render stored amounts only, including when printing a historical confirmation. */
export function TimedSettlementBudgetSummary({
  totals,
  calculationRevision,
}: {
  totals: TimedSettlementFinancialTotals;
  calculationRevision?: number;
}) {
  const { t } = useTranslation('tournament');
  const fields = [
    ['prizePoolPrincipal', 'timedPrincipal'],
    ['activityFee1Total', 'timedActivityFee1'],
    ['netPool', 'timedNetPool'],
    ['rankBudget', 'timedRankBudget'],
    ['basePrizePool', 'timedBasePool'],
    ['baseResidual', 'timedBaseResidual'],
    ['rankResidual', 'timedRankResidual'],
    ['totalAwards', 'timedTotalAwards'],
    ['activityFee2', 'timedActivityFee2'],
  ] as const;
  return (
    <div className="space-y-2" aria-label={t('timedBudgetSummary')}>
      <p className="text-xs">
        {t('timedCalculationRevision', {
          revision: calculationRevision ?? t('timedUnknownRevision'),
        })}
        {' · '}
        {t(calculationRevision === 3 ? 'timedBaseFormula' : 'timedHistoricalFormula')}
      </p>
      <dl className="grid gap-2 text-sm sm:grid-cols-2 lg:grid-cols-3">
        {fields.map(([field, label]) => (
          <div key={field}>
            <dt className="inline">{t(label)}：</dt>
            <dd className="inline">{totals[field]?.toLocaleString() ?? '—'}</dd>
          </div>
        ))}
      </dl>
      {calculationRevision === 3 && <p className="text-xs">{t('timedResidualExplanation')}</p>}
    </div>
  );
}
